"use strict";

import React from 'react';
import OrderSampleItem from "./OrderSampleItem";

const OrderSampleItems = ({isTopsOrder=false, sampleItems=[]}) => {
    const key = isTopsOrder ? 'id' : 'li_id';
    if(sampleItems.length){
        return (
            <div>
                <div className="">
                    <h4 className=""
                        style={{display: 'inline-block',marginRight: '1rem'}}>
                        Product Samples
                    </h4>
                    <span className="label label--round">{sampleItems.length}</span>
                </div>
                <ul className="cart__component__list">
                    { sampleItems.map( (item, index)=>
                        <OrderSampleItem key={item[key]} item={item} />
                    )}
                </ul>
            </div>
        );
    }
    return null;
};

export default OrderSampleItems;